import { MonitorPlay } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { computerUseWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  computerUseWeb,
  {
    DesktopTab: () => import('./DesktopTab'),
    DesktopTabPreview: () => import('./DesktopTabPreview'),
  },
  {
    icons: { MonitorPlay },
  },
);
